import { Col, Row } from "antd";
import "./styled/security.scss";
import { useTranslation } from "react-i18next";
import SliderBannerLogin from "./slider-banner";

const LayoutLogin = ({ children }) => {
	const [t] = useTranslation("global");
	return (
		<>
			<div className="security-container">
				<div className="security-box">
					<Row className="Row">
						<Col xl={20} lg={15} md={24} sm={24} xs={24} style={{ margin: "auto" }} className="col">
							<div className="holder-box">
								<div className="holder-fix-middle">
									<Row style={{ height: "100%" }}>
										<Col xl={12} lg={24} md={24} sm={15} xs={24} style={{ margin: "auto" }} className="col-form">
											<Row>
												<Col xl={12} lg={24} md={15} sm={15} xs={24} style={{ margin: "auto" }}>
													<div className="form-box-handle">
														<div className="holder-icon">
															<img src={process.env.PUBLIC_URL + process.env.REACT_APP_PATH + "/assets/images/logo-big.png"} alt="" />
															<img src={process.env.PUBLIC_URL + process.env.REACT_APP_PATH + "/assets/images/text-logo.png"} alt="" />
														</div>
														<div className="holder-form">{children}</div>
													</div>
												</Col>
											</Row>
										</Col>
										<Col xl={12} className="col-slider" style={{ margin: "auto" }}>
											<Row>
												<Col span={20} style={{ margin: "auto" }}>
													<div className="banner-box-handle">
														<SliderBannerLogin />
													</div>
												</Col>
											</Row>
										</Col>
									</Row>
								</div>
								<div className="holder-fix-footer">
									<Row>
										<Col span={24}>
											<div className="form-box-handle">
												<div className="holder-notis">
													<ul>
														<li>
															<a href="https://www.aptel.ir/WebSite/ApTel/Dealer/RegisterDealer" target="_blank">
																<i className="icon-pdf"></i>
																اطلاعات توزیع کنندگان جهت دریافت نمایندگی و خرید کیت
															</a>
														</li>
														{/* <li>
															<a href="/#" download>
																<i className="icon-pdf"></i>
																نحوه درخواست دریافت نمایندگی فروش آپتل
															</a>
														</li> */}
													</ul>
												</div>
											</div>
										</Col>
										{/* <Col xs={24} sm={24} xl={12} lg={12} style={{ margin: "auto" }}></Col> */}
									</Row>
									<Row>
										<Col span={24}>
											<div className="holder-footer text-center">
												<p
													dangerouslySetInnerHTML={{
														__html: t("form.footer_login"),
													}}
												/>
											</div>
										</Col>
									</Row>
								</div>
							</div>
						</Col>
					</Row>
				</div>
			</div>
		</>
	);
};

export default LayoutLogin;
